import React from 'react';
import {Field} from 'redux-form';

import {positiveInteger} from 'utils/validators';

import Label from 'components/Label';
import FormField from 'components/FormField';
import {NumberField, CheckBoxField} from 'components/Fields';

import './styles.css';

export const initialValues = () => ({
  createCleanupPeriod: true,
  cleanupPeriodDays: 3
});

const CleanupPeriodSection = ({
  createCleanupPeriodValue,
  onCleanupPeriodCheckboxChange,
  onCleanupPeriodDaysChange
}) => (
  <div className="CleanupPeriodSection">
    <div className="formContainer">
      <FormField className="createCleanupPeriodField">
        <Field
          name="createCleanupPeriod"
          className="createCleanupPeriod"
          component={CheckBoxField}
          onChange={onCleanupPeriodCheckboxChange}
          label="Include a cleanup period"
        />
      </FormField>
      {createCleanupPeriodValue && (
        <FormField>
          <Label>Cleanup period duration</Label>
          <div className="cleanupPeriodDays">
            <Field
              name="cleanupPeriodDays"
              className="cleanupPeriodDays"
              component={NumberField}
              onChange={onCleanupPeriodDaysChange}
              validate={[positiveInteger]}
            />
            <div className="label">Days</div>
          </div>
        </FormField>
      )}
    </div>
  </div>
);

export default CleanupPeriodSection;
